Indicates whether the position should be suspended.
